import { useState, useEffect } from "react";
import "../styling/Bookings.css";
import EventsTable from "./tables/EventsTable";
import EventInfoTile from "./tiles/EventInfoTile";
import CreateBookingModal from "./modals/CreateBookingModal";
import axios from "axios";

const Bookings = ({ onEventClick, setInitialBusinessEventTab }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [event, setEvent] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // 1. Added a loading state

  useEffect(() => {
    fetchEvents();
  },[]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const fetchEvents = async () => {
    setIsLoading(true); // Start loading
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/events`, {
        withCredentials: true,
      });
      setEvent(response.data.data);

    } catch (error) {
      console.log(
        "Something went wrong while fetching latest events....",
        error
      );
    } finally {
      setIsLoading(false);
    }
  };


  // BUGFIX: TABLE RESIZING WHILE LOADING

  // <div style={{width: "98%" , minWidth: 0, overflowX: "hidden"}}>
  //     <h1 style={{ color: "#1C1154", marginTop: "20px", marginLeft: '0px' }}>Events</h1>

  //     <EventInfoTile  />
      
  //     {/* --- THIS IS THE MISSING PIECE --- */}
  //     {/* We hold the space with minHeight, and ONLY render the table when loading is false */}
  //     <div style={{ minHeight: "300px" }}>
  //       {isLoading ? (
  //          <div style={{ padding: "40px", textAlign: "center", color: "#625C73", fontSize: "16px" }}>
  //            Loading events...
  //          </div>
  //       ) : (
  //         <EventsTable 
  //           event={event} 
  //           onEventClick={onEventClick} 
  //           setInitialBusinessEventTab={setInitialBusinessEventTab}
  //         />
  //       )}
  //     </div>
  //     {/* --------------------------------- */}

  //     <CreateBookingModal isModalOpen={isModalOpen} closeModal={closeModal} />
  //   </div>

  return (
    <div style={{width: "98%" , minWidth: 0, overflowX: "hidden"}}>
      <h1 style={{ color: "#1C1154", marginTop: "20px", marginLeft: '0px' }}>Events</h1>

      <EventInfoTile  />
      <EventsTable event={event} onEventClick={onEventClick} setInitialBusinessEventTab={setInitialBusinessEventTab}/>
      <CreateBookingModal isModalOpen={isModalOpen} closeModal={closeModal} />
    </div>
  );
};

export default Bookings;
